import { render, staticRenderFns } from "./SubscriptionSuccess.vue?vue&type=template&id=0bbf96c8"
import script from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
export * from "./SubscriptionSuccess.vue?vue&type=script&lang=js"
import style0 from "./SubscriptionSuccess.vue?vue&type=style&index=0&id=0bbf96c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports